import { Trans } from "@lingui/react/macro";
import { MoreVertical } from "lucide-react";
import { useDisclosure } from "@mantine/hooks";
import RemoveCustomerFromAppointmentModal from "./RemoveCustomerFromAppointmentModal";
import { useState } from "react";
import {
  Button,
  Chip,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@heroui/react";

type Customer = {
  name: string;
  lastName: string;
  userAppointmentId: number;
  customerId: number;
  customerDidAttend: number;
  customerSubscriptionId: number;
};
export const CustomerList = ({
  customers,
  selectedUserAppointment,
  handleUserAppointmentSelect,
  openCustomerCard,
  appointmentId,
  fetchAppointmentData,
}: {
  appointmentId: number;
  customers: Customer[];
  handleUserAppointmentSelect: (userAppointmentId: number) => void;
  selectedUserAppointment: number;
  openCustomerCard: (customerId: number) => void;
  fetchAppointmentData: (appointmentId: number) => void;
}) => {
  // Track which userAppointmentId we want to remove
  const [activeUserAppointmentId, setActiveUserAppointmentId] = useState<
    number | null
  >(null);

  const [
    isRemoveCustomerFromAppointmentModalOpen,
    {
      open: openRemoveCustomerFromAppointmentModal,
      close: closeRemoveCustomerFromAppointmentModal,
    },
  ] = useDisclosure(false);

  const handleOpenRemoveModal = (userAppointmentId: number) => {
    setActiveUserAppointmentId(userAppointmentId);
    openRemoveCustomerFromAppointmentModal();
  };

  return (
    <div className="flex-1">
      {activeUserAppointmentId && (
        <RemoveCustomerFromAppointmentModal
          isOpen={isRemoveCustomerFromAppointmentModalOpen}
          onClose={() => {
            closeRemoveCustomerFromAppointmentModal();
            fetchAppointmentData(appointmentId);
          }}
          appointmentId={appointmentId}
          userAppointmentId={activeUserAppointmentId}
        />
      )}

      {customers.map((customer) => (
        <Button
          variant={
            customer.userAppointmentId === selectedUserAppointment
              ? "bordered"
              : "light"
          }
          onPress={() =>
            handleUserAppointmentSelect(customer.userAppointmentId)
          }
          className="flex w-full justify-between rounded-lg p-2 py-2"
          key={customer.customerId}
          data-identifier="customer-list-item"
        >
          <div className="flex items-center gap-2">
            <p>
              {customer.name} {customer.lastName}
            </p>
            <Chip
              color={customer.customerDidAttend === 1 ? "success" : "danger"}
              size="sm"
              variant="flat"
            >
              {customer.customerDidAttend === 1 ? (
                <Trans>Prisoten</Trans>
              ) : (
                <Trans>Odsoten</Trans>
              )}
            </Chip>
            {customer.customerSubscriptionId ? (
              <Chip color="primary" size="sm">
                <Trans>Naročnina</Trans>
              </Chip>
            ) : null}
          </div>
          <div className="flex justify-end gap-1">
            <Dropdown placement="bottom-end" showArrow>
              <DropdownTrigger data-identifier="customer-list-three-dots">
                <Button isIconOnly variant="light">
                  <MoreVertical size={16} />
                </Button>
              </DropdownTrigger>

              <DropdownMenu>
                <DropdownItem
                  onPress={() => openCustomerCard(customer.customerId)}
                  key="customer-card"
                  data-identifier="customer-list-item-customer-card"
                >
                  <p className="text-sm">
                    <Trans>Kartica stranke</Trans>
                  </p>
                </DropdownItem>

                <DropdownItem
                  key="remove-customer-from-appointment-item"
                  data-identifier="remove-customer-from-appointment-item"
                  color="danger"
                  variant="flat"
                  onPress={() => {
                    handleOpenRemoveModal(customer.userAppointmentId);
                  }}
                >
                  <p className="text-sm">
                    <Trans>Odstrani stranko s termina</Trans>
                  </p>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </Button>
      ))}
    </div>
  );
};
